// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js!./kt1-integration-fixes.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js!./ionic-overrides.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);"]);
// Module
exports.push([module.id, "/*Needed for web app only running on win/linux*/\n\n.ios {\n    --ion-font-family:-apple-system,BlinkMacSystemFont,\"Helvetica Neue\",\"Roboto\",sans-serif\n}\n\n.md {\n    --ion-font-family:\"Roboto\",\"Helvetica Neue\",sans-serif\n}\n\nbody{\n    background-color: #e7ebf0 !important;\n    padding: 0; margin: 0;\n}", ""]);
// Exports
module.exports = exports;
